import { render, staticRenderFns } from "./CloudAssetIssueBody.vue?vue&type=template&id=04ad2a33&scoped=true"
import script from "./CloudAssetIssueBody.vue?vue&type=script&lang=js"
export * from "./CloudAssetIssueBody.vue?vue&type=script&lang=js"
import style0 from "./CloudAssetIssueBody.vue?vue&type=style&index=0&id=04ad2a33&prod&lang=scss&scoped=true"
import style1 from "./CloudAssetIssueBody.vue?vue&type=style&index=1&id=04ad2a33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad2a33",
  null
  
)

export default component.exports